/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable implicit-arrow-linebreak */
import { defineStore } from 'pinia';
import { getActConfig, BankTypes } from '@tencent/wphk-act-base-framework';
import { url, CustomException } from '@tencent/ppd-base-libs';

type StoreType = {
  config: BankTypes.ActConfig;
};
export const userConfigStore = defineStore({
  id: 'config',
  state: () =>
    ({
      config: {},
    } as StoreType),
  getters: {},
  actions: {
    async init() {
      const business = url.getUrlParam('business');
      console.log('business: ', business);
      if (!business) {
        throw new CustomException(business, 'getActBusinessFail', '获取参数失败');
      }
      this.config = await getActConfig(business);
      console.log('getActConfig: ', JSON.stringify(this.config));
    },
  },
});
